import { useState, useContext, useEffect } from "react";
import { CanvasContext } from "../App";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { RiMenu2Fill } from "react-icons/ri";
import Menu from "./Menu";
import styled from "styled-components";

const CustomOffcanvas = styled(Offcanvas)`
  background-color: #343a40;
  color: white !important;
  font-weight: 300 !important;
`;

function MenuOffcanvas({ isOpen, changeData }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const canvas = useContext(CanvasContext);

  useEffect(() => {
    canvas && setShow(false);
  }, [canvas, isOpen]);

  //console.log("Canvas isOpen: ", isOpen);

  return (
    <>
      <Button
        variant="none"
        onClick={handleShow}
        style={{
          backgroundColor: "#1a2236",
          color: "#ffffff",
          width: "80vw",
          maxWidth: "400px",
          margin: "0 auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "12px",
          padding: "12px 24px",
          borderRadius: "20px",
          fontSize: "15px",
          fontWeight: "600",
          letterSpacing: "0.05em",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          transition: "all 0.2s ease-in-out",
          marginLeft: "10%",
        }}
      >
        <span>MENU</span>
        <RiMenu2Fill size={30} />
      </Button>
      <CanvasContext.Provider value={show}>
        <CustomOffcanvas show={show} onHide={handleClose} className="offcanvas">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title
              style={{
                width: "100%",
                textAlign: "center",
              }}
            >
              Michał Jaskulski
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Menu isOpen="true" changeData={changeData} />
          </Offcanvas.Body>
        </CustomOffcanvas>
      </CanvasContext.Provider>
    </>
  );
}

export default MenuOffcanvas;
